import { generatePath } from 'react-router-dom';
import { routes } from '$src/routes';
import { CLICK, CANCEL_FREE_TRIAL_ACTION_ID } from '$src/constants/actions';
import moment from 'moment';

import NavigationTitle from '$src/components/NavigationTitle';
import { history } from '$src/stores/history';
import { ModalCustom } from '$src/components/Modal';
import useModalEvents from '$src/hooks/useModalEvents';
import useStores from '$src/hooks/useStores';
import useLocationContext from '$src/hooks/useLocationContext';
import { Ingress } from '@amzn/ring-react-components/csr/components/Ingress';
import { TwofaIcon, PlanBenefitsIcon, CloseIcon } from '@ring-icons';

import './TrialManagement.less';
import Benefits from '../TrialBenefits/Benefits';

function TrialManagement() {
  const locationId = useLocationContext();
  const [handleModalClick, showModal] = useModalEvents();
  const { locationContextStore, statsStore } = useStores();
  const { locationOwnerId, location } = locationContextStore;
  const freeTrialExpirationTimestamp = moment.unix(location?.freeTrialExpirationTimestamp);
  const expirationDays = freeTrialExpirationTimestamp.diff(new Date(), 'days');

  const cancelTrialHandler = () => {
    locationContextStore.cancelFreeTrial(locationOwnerId, () => history.push(routes.freeTrialCanceled));
    statsStore.sendStats(CLICK, undefined, CANCEL_FREE_TRIAL_ACTION_ID);
  };

  return (
    <>
      <div className="trial-management page-devices-wrapper" data-testid="trial-management">
        <NavigationTitle title="Trial Management" icon={TwofaIcon}>
          Live video monitoring by highly-trained security professionals who can see and speak to people to deter unwanted activity and dispatch
          emergency services.
          <b data-testid={expirationDays > 0 ? 'trial-not-expired' : 'trial-expired'}>
            {expirationDays > 0
              ? `Trial will expire in ${expirationDays + (expirationDays === 1 ? ' day' : ' days')} or after ${location?.overagesThreshold
              } Guard reviewed
            events.`
              : 'Trial has expired.'}
          </b>
        </NavigationTitle>
        <div className="trial-management__ingress--title">Virtual Security Guard Benefits</div>

        <Ingress
          image={<PlanBenefitsIcon />}
          data-testid="benefits-access"
          onClick={() => {
            history.push({ pathname: generatePath(routes.trialBenefits, { locationId }), state: { displayingSublevel: true } });
          }}
          title="Trial Benefits"
        />

        <div className="trial-management__ingress--title">Cancel Plan</div>
        <Ingress
          image={<CloseIcon height="30" width="18" />}
          onClick={handleModalClick}
          data-testid="cancel-free-trial-button"
          title="Cancel Trial"
        />
      </div>
      <ModalCustom
        title="Virtual Security Guard Trial"
        data-testid="cancel-free-trial-modal"
        contentTitle="By cancelling your Free trial you will lose access to Virtual Security Guard benefits, this cannot be undone."
        width="650px"
        contentMessage={<Benefits className="trial-management" title="Virtual Security Guard Benefits:" />}
        visible={showModal}
        setModalVisible={handleModalClick}
        handleOk={cancelTrialHandler}
        okText="Cancel Trial"
        cancelText="Keep Trial"
      />
    </>
  );
}

export default TrialManagement;
